import { parse } from "date-fns";

import { IBilling } from "store/entities/billing/interfaces";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
function parseBillingInfo(billingInfo: { [key: string]: any }) {
  if (!billingInfo) {
    return null;
  }

  return {
    address: billingInfo.address,
    address2: billingInfo.address2,
    city: billingInfo.city,
    region: billingInfo.region,
    company: billingInfo.company,
    country: billingInfo.country,
    creditCard: {
      cardType: billingInfo.credit_card.card_type,
      firstSix: billingInfo.credit_card.first_six,
      lastFour: billingInfo.credit_card.last_four,
      month: billingInfo.credit_card.month,
      year: billingInfo.credit_card.year,
    },
    firstName: billingInfo.first_name,
    lastName: billingInfo.last_name,
    phone: billingInfo.phone,
    vatNumber: billingInfo.vat_number,
    zip: billingInfo.zip,
  };
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deserialize(data: { [key: string]: any }): IBilling {
  return {
    accountCode: data.account_code,
    createdAt: parse(data.created_at),
    invoiceEmails: data.emails,
    state: data.state,
    billingInfo: parseBillingInfo(data.billing_info),
  };
}
